<template>
  <div>
    <slot :data="cData" :loading="loading" :empty="empty"></slot>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <!-- <div slot="spinner">Loading...</div> -->
      <div slot="no-more" class="nomore_data">
        <span v-if="text != ''">{{text}}</span>
      </div>
      <div slot="no-results" class="noresult_data">
        {{ nrtxt }}
      </div>
      <div slot="error" class="result_error" slot-scope="{ trigger }">
        出错了，请刷新&nbsp;&nbsp;<a class="here" href="javascript:;" @click="trigger">here</a>
      </div>
    </infinite-loading>
  </div>
</template>

<script>
  import {
    debounce
  } from 'riku-verycloud'
  import InfiniteLoading from "vue-infinite-loading";
  export default {
    name: "infi-scroll",
    components: {
      InfiniteLoading,
    },
    data() {
      return {
        page: 1,
        data: [],
        loading: 0,
        infiniteId: 1,
      };
    },
    //返回时要修改
    props: {
      text: {
        type: String,
        default: "到底了",
      },
      pagesize: {
        type: Number,
        default: 10,
      },
      url: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        default () {
          return {};
        },
      },
      nrtxt: {
        type: String,
        default: "暂无数据",
      },
      computeData: Function,
      method: {
        type: String,
        default: "post",
      }
    },
    computed: {
      sendData() {
        return {
          ...this.params,
          page: this.page,
          pagesize: this.pagesize,
        };
      },
      trigger() {
        return this.url + "?" + this.$QueryString.stringify(this.params);
      },
      cData() {
        return (
          (typeof this.computeData === "function" ?
            this.computeData(this.data) :
            this.data) || []
        );
      },
      empty() {
        return !this.cData.length;
      },
    },
    methods: {
      //     norepeat(arr) {
      //        for(var i = 0; i < arr.length-1; i++){
      //            for(var j = i+1; j < arr.length; j++){
      //             if(arr[i].id===undefined) continue;
      //                if(arr[i].id==arr[j].id){
      //                    arr.splice(j,1);
      //                    j--;
      //                }
      //            }
      //        }
      //        return arr;
      //    },
      infiniteHandler: debounce(function ($state) {
        if (!this.$store.state.gameId) {
          // this.$filterPop({
          //   type: 'game'
          // })
          return
        }
        if (this.sendData.server_id) {    
          this.loading++;
          this.$Ajax(this.url, this.sendData, this.method)
            .then(rs => {
              this.page++;
              this.$emit("on-fetch", {
                data: rs.data.list,
                total: rs.data.total,
              });
              if (
                rs.code == 200 &&
                rs.data.list instanceof Array &&
                rs.data.list.length > 0
              ) {
                this.data.push(...rs.data.list);
                $state.loaded();
              } else {
                // setTimeout(() => {
                //   if (this.url == 'goods/index' && (this.$store.state.role_id == '' || this.$store.state
                //       .role_id == undefined)) {
                //     this.$RModal.bindtips()
                //   }
                // }, 500)
              }
              if (!rs.data.totalpage || this.page > rs.data.totalpage) {
                $state.complete();
              }
            })
            .finally(() => {
              this.loading--;
            });
        } else {
          $state.complete();
          this.$filterPop({
            type: 'server',
            direction: 'up'
          })
          // setTimeout(() => {
          //   this.$RModal.bindtips()
          // }, 500)
        }
      }),
      refresh() {
        this.page = 1;
        this.data = [];
        this.infiniteId++;
      },
    },
    watch: {
      trigger: "refresh",
    },
  };
</script>

<style lang="less" scoped>
  .nomore_data,
  .noresult_data,
  .result_error {
    color: #aaa;
    font-size: 1.4rem;
    padding: 1rem 0;

    .van-divider {
      margin: 0;
      font-size: 1.2rem;
      line-height: unset;
    }

    .van-icon-warning {
      font-size: 1.4rem;
      margin-right: 0.6rem;
    }

    .here {
      color: var(--theme);
    }
  }
</style>